/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useThree } from '@react-three/fiber';
import { useDrag } from '@use-gesture/react';
import debounce from 'lodash.debounce';

import { const_var, params } from '../../../../../redux/reducers/reducer';
import { controls } from '../../../../../redux/reducers/common/eventReducer';
import { makeTranslucent } from '../../../../../helpers/building/building_config/componentConfig';
import * as actionCreator from '../../../../../action/index';

import FrontWall from './FrontWall';
import BackWall from './BackWall';
import LeftWall from './LeftWall';
import RightWall from './RightWall';
import Legs from './Legs';
import OutLineSection from '../BackStorage/OutLineSection';
import DoorWindows from '../../../DoorWindows';

const BackStorage = () => {
    const dispatch = useDispatch();
    const prevBuildingTypeRef = useRef();
    const prevStorageLengthRef = useRef();
    const prevBuildingLengthRef = useRef();
    const get = useThree((state) => state.get)
    const distance = const_var?.controls?.getDistance?.([0, 0, 0]);
    const mainTrussPosInfo = useSelector(state => state.reducer.mainTrussPosInfo)
    const isActiveWallSubTab = useSelector(state => state.reducer.isActiveWallSubTab)
    const isResetBuilding = useSelector(state => state.reducer.isResetBuilding)

    const [isDragable, setIsDragable] = useState(true);
    const [isHovered, setIsHovered] = useState(true);
    const [positionZ, setPositionZ] = useState(params.endStoragePositionZ)
    const [startPositionZ, setStartPositionZ] = useState(positionZ);
    const [overlapTrussArr, setOverlapTrussArr] = useState(false);
    const [dragging, setDragging] = useState(false);

    const prevBuildingTypeValue = prevBuildingTypeRef.current;
    const prevBuildingLengthValue = prevBuildingLengthRef.current;
    const prevStorageLengthValue = prevStorageLengthRef.current;
    const camPosX = const_var.camera?.position?.x;

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset = 1
    if(camPosX >= 0) offset = 1;
    else if(camPosX < 0) offset = -1;

    const limitZ = useMemo(() => {
        const min = 0;
        const max = params.p_d - parseInt(params.p_u_t);

        return {
            min, max
        }
    
    }, [params.p_d, params.p_u_t])
    
    const debounceForDragLean = debounce(() => {
        setTimeout(() => {
            setIsDragable(true)
            get().gl.domElement.style.cursor = 'auto'
            clearTimeout();
        }, [750])
    }, [750])

    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {

            event.stopPropagation();
            if (controls.isCheckActiveTab === 'walls' && isActiveWallSubTab === 'center_building' && const_var.isStorageMovementEnableForMfg) {
                if (first) {
                    if (!params.is_translusant) makeTranslucent(null, null, params.is_translusant, const_var.scene, true, 'center-storage');
                    setStartPositionZ(positionZ);
                }
                
                if (down === true) {
                    dispatch(actionCreator.updateEditIconVisiblity())
                    const_var.controls.enableRotate = false;
                    
                    if (isDragable) {
                        get().gl.domElement.style.cursor = 'move';
                        
                        const nextPositionZ = startPositionZ + (-mx * offset) * (distance / 1000);
                        if (nextPositionZ < limitZ.min) {
                            setPositionZ(limitZ.min)
                        } else if (nextPositionZ > limitZ.max) {
                            setPositionZ(limitZ.max)
                        } else {
                            setPositionZ(nextPositionZ)
                        }
                        setDragging(true)
                    }
                } else {
                    setIsDragable(false);
                    if (!params.is_translusant) makeTranslucent(null, null, params.is_translusant, const_var.scene, false, 'center-storage');

                    const newPositionZ = mainTrussPosInfo.reduce((prev, curr) => Math.abs(curr - positionZ + params.p_d / 2) < Math.abs(prev - positionZ + params.p_d / 2) ? curr : prev);
                    const_var.controls.enableRotate = true;
                    get().gl.domElement.style.cursor = 'auto'

                    let tempPositionZ = 0;
                    if(params.p_d - positionZ - parseInt(params.p_u_t) < legDistance / 2){
                        tempPositionZ = parseFloat((params.p_d - parseInt(params.p_u_t)).toFixed(4));
                    } else if (newPositionZ + params.p_d / 2 < legDistance / 2) {
                        tempPositionZ = 0;
                    } else {
                        tempPositionZ = parseFloat((Math.round(newPositionZ * 10) / 10 + params.p_d / 2).toFixed(4));
                    }  
                    
                    let isFindRight = false;
                    let isFindLeft = false;
                    const doorsArray = [...const_var.newDoorsArray]
                    const storageRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_r_s_w');
                    const cbRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_r_w');
                    const storageLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_l_s_w');
                    const cbLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_l_w');

                    if (storageRightSideDoorsArr.length > 0 && cbRightSideDoorsArr.length > 0) {
                        storageRightSideDoorsArr.forEach(item_st => {
                            const tempChangedDoorPosX = item_st.positionX - (tempPositionZ - startPositionZ);

                            cbRightSideDoorsArr.forEach(item_cb => {
                                if (Math.abs(item_cb.positionX - tempChangedDoorPosX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                    Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                                {
                                    isFindRight = true;
                                }
                            })
                        })
                    }
                    if (storageLeftSideDoorsArr.length > 0 && cbLeftSideDoorsArr.length > 0) {
                        storageLeftSideDoorsArr.forEach(item_st => {
                            const tempChangedDoorPosX = item_st.positionX + (tempPositionZ - startPositionZ);

                            cbLeftSideDoorsArr.forEach(item_cb => {
                                if (Math.abs(item_cb.positionX - tempChangedDoorPosX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                    Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                                {
                                    isFindLeft = true;
                                }
                            })
                        })
                    }
                    
                    if (isFindRight || isFindLeft) {
                        dispatch(actionCreator.handleShowAlertBox("notAllowNewPosition"));
                        setPositionZ(startPositionZ)
                        setStartPositionZ(startPositionZ)
                    } else {
                        setPositionZ(tempPositionZ)
                        setStartPositionZ(tempPositionZ);
                        dispatch(actionCreator.onDragUtilityPriceReset("center_building"));
                        dispatch(actionCreator.updateEndStoragePositionZ(tempPositionZ, startPositionZ, true))
                        
                        const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                            if (item.userData.wallName === 'c_b_l_s_w' || item.userData.wallName === 'c_b_r_s_w') {
                                return {
                                    ...item,
                                    positionX: item.userData.wallName === 'c_b_r_s_w' ? item.positionX - (tempPositionZ - startPositionZ) : item.positionX + (tempPositionZ - startPositionZ),
                                
                                    minLimitX: item.minLimitX + (tempPositionZ - startPositionZ),
                                    maxLimitX: item.maxLimitX + (tempPositionZ - startPositionZ)
                                }
                            }
                            return item;
                        })

                        if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                            dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                        }
                        let newArray;
                        if(positionZ === params.p_d - parseInt(params.p_u_t)){
                            if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_f_w")) {
                                newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "c_b_f_s_w")
                                dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                            } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_f_s_w")){
                                const_var.newDoorsArray.filter(item => item.userData.wallName === "c_b_f_s_w").map(item => item.userData.wallName = "c_b_f_w");
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                            }
                        } else if(params.endStoragePositionZ === 0){
                            if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_b_w")) {
                                newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "c_b_b_s_w")
                                dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                            } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_b_s_w")) {
                                const_var.newDoorsArray.filter(item => item.userData.wallName === "c_b_b_s_w").map(item => item.userData.wallName = "c_b_b_w");
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                            }
                        }
                    }

                    setDragging(false)
                    debounceForDragLean()
                }
            }
        },
    );
    
    useMemo(() => {
    }, [params.p_d, params.p_u_t])

    // useMemo(() => {
    //     const newPositionZ = mainTrussPosInfo.reduce((prev, curr) => Math.abs(curr - positionZ + params.p_d / 2) < Math.abs(prev - positionZ + params.p_d / 2) ? curr : prev);
    //     if(params.p_d - positionZ - parseInt(params.p_u_t) < legDistance / 2){
    //         setPositionZ(params.p_d - parseInt(params.p_u_t))
    //         setStartPositionZ(params.p_d - parseInt(params.p_u_t));
    //         dispatch(actionCreator.updateEndStoragePositionZ(params.p_d - parseInt(params.p_u_t), startPositionZ, true))
    //     } else{
    //         setStartPositionZ(newPositionZ + params.p_d / 2)
    //         setPositionZ(newPositionZ + params.p_d / 2)
    //         dispatch(actionCreator.updateEndStoragePositionZ(newPositionZ + params.p_d / 2, startPositionZ,true))
    //     }
    // }, [params.p_d, mainTrussPosInfo])
    
    useMemo(() => {
        // Store the previous storage size(p_u_t) value
        prevBuildingTypeRef.current = params.building_type_name;
        prevStorageLengthRef.current = parseInt(params.p_u_t);
        prevBuildingLengthRef.current = params.p_d;

        if(prevBuildingTypeValue === params.building_type_name && prevStorageLengthValue >= params.p_d){
            // Remove End Storage if the building length is smaller than storage size.
            // dispatch(actionCreator.nostorage(false, params.nostorage, true))
        } else {
            if (!isResetBuilding && !dragging && (prevBuildingLengthValue > params.p_d || prevBuildingLengthValue < params.p_d|| prevStorageLengthValue < parseInt(params.p_u_t))) {
                if(params.p_d - positionZ - parseInt(params.p_u_t) <= 0) {
                    const newPositionZ = params.p_d - parseInt(params.p_u_t);
                    setPositionZ(newPositionZ)
                    setStartPositionZ(newPositionZ)
                    dispatch(actionCreator.updateEndStoragePositionZ(newPositionZ));
                            
                    const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                        if (item.userData.wallName === 'c_b_l_s_w' || item.userData.wallName === 'c_b_r_s_w') {
                            return {
                                ...item,
                                positionX: item.userData.wallName === 'c_b_r_s_w' ? item.positionX - (newPositionZ - startPositionZ) : item.positionX + (newPositionZ - startPositionZ),
                                
                                minLimitX: item.minLimitX + (newPositionZ - startPositionZ),
                                maxLimitX: item.maxLimitX + (newPositionZ - startPositionZ)
                            }
                        }
                        return item;
                    })

                    if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                        dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                    }
                }
                    
                // Remove doors/windows when they are overlapping
                const doorsArray = [...const_var.newDoorsArray]
                const storageRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_r_s_w');
                const cbRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_r_w');
                const storageLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_l_s_w');
                const cbLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'c_b_l_w');
                
                let updatedDoorsWindowsArr = doorsArray;
                if (storageRightSideDoorsArr.length > 0 && cbRightSideDoorsArr.length > 0) {
                    storageRightSideDoorsArr.forEach(item_st => {
                        cbRightSideDoorsArr.forEach(item_cb => {
                            if (Math.abs(item_cb.positionX - item_st.positionX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                            {
                                updatedDoorsWindowsArr = updatedDoorsWindowsArr.filter(item => item.uniqueId !== item_cb.uniqueId)
                            }
                        })
                    })
                }
                if (storageLeftSideDoorsArr.length > 0 && cbLeftSideDoorsArr.length > 0) {
                    storageLeftSideDoorsArr.forEach(item_st => {
                        cbLeftSideDoorsArr.forEach(item_cb => {
                            if (Math.abs(item_cb.positionX - item_st.positionX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                            {
                                updatedDoorsWindowsArr = updatedDoorsWindowsArr.filter(item => item.uniqueId !== item_cb.uniqueId)
                            }
                        })
                    })
                }
                dispatch(actionCreator.updateDoorWindowsArray(updatedDoorsWindowsArr, true));
            }

            let newArray;
            if(positionZ === params.p_d - parseInt(params.p_u_t)){
                if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_f_w")) {
                    newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "c_b_f_s_w")
                    dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_f_s_w")){
                    const_var.newDoorsArray.filter(item => item.userData.wallName === "c_b_f_s_w").map(item => item.userData.wallName = "c_b_f_w");
                    dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                }
            } else if(params.endStoragePositionZ === 0){
                if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_b_w")) {
                    newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "c_b_b_s_w")
                    dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "c_b_b_s_w")) {
                    const_var.newDoorsArray.filter(item => item.userData.wallName === "c_b_b_s_w").map(item => item.userData.wallName = "c_b_b_w");
                    dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                }
            }
        }
    }, [params.p_d, params.p_u_t, params.building_type_name, params.endStoragePositionZ]);

    useEffect(() => {
        setPositionZ(positionZ)
    }, [positionZ])
 useMemo(() => {
        setPositionZ((item) => {
                return params.endStoragePositionZ;
            }
        );
    }, [params.endStoragePositionZ]);
    useMemo(() => {
        setPositionZ((item) => {
                return params.endStoragePositionZ;
            }
        );
    }, [params.endStoragePositionZ]);

    useMemo(() => {
    }, [params.p_d, positionZ, params.p_u_t])

    useMemo(() => {
        if((!params.apiCallAfterEdit || isResetBuilding) && !const_var.isFromPickThis){
            setPositionZ(0);
            setStartPositionZ(0)
            dispatch(actionCreator.updateEndStoragePositionZ(0));
            if(isResetBuilding){
               dispatch(actionCreator.handleIsResetBuildingState());
            }
        }else{
            setPositionZ(params.endStoragePositionZ);
            setStartPositionZ(params.endStoragePositionZ)
            dispatch(actionCreator.updateEndStoragePositionZ(params.endStoragePositionZ));
        }
    }, [params.building_type_name, isResetBuilding])

    return (
        <group
            {...bind()}
            position={[0, 0, positionZ]}
            onPointerOver={(e) => {e.stopPropagation(); setIsHovered(true)}}
            onPointerOut={() => setIsHovered(false)}
            name='center-storage'
        >
            {params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t) &&  <FrontWall/>}
            {params.endStoragePositionZ !== 0 &&  <BackWall/>}
            <LeftWall/>
            <RightWall/>
            <Legs/>
            <group position={dragging ? undefined : [0, 0, -positionZ]}>
                <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} section={'center-storage-back'} />
            </group>
            {controls.isCheckActiveTab === 'walls' && isActiveWallSubTab === 'center_building' && const_var.isStorageMovementEnableForMfg && isHovered && <OutLineSection/>}
        </group>
    )
}

export default BackStorage
